/** W25: the container the Cloudflare Turnstile widget renders into (browser builds only). */
export function TurnstileBox({
  boxRef,
  label,
  error,
}: {
  boxRef: (element: HTMLDivElement | null) => void;
  label: string;
  error?: string | null;
}) {
  return (
    <div className="space-y-1">
      <div ref={boxRef} role="group" aria-label={label} className="min-h-16.5 w-full" />
      {error && <p className="text-xs text-negative">{error}</p>}
    </div>
  );
}
